"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box, Button } from "@mantine/core";
import { forwardRef } from "react";
import Button$1 from "../Button/Button.js";
import '../../../assets/ButtonGroup.css';const root = "_root_7h7ov_2";
const ButtonGroupStyles = {
  root
};
const _ButtonGroup = forwardRef((props, ref) => {
  const { buttons, type, variant, disabled, fullWidth, ...rest } = props;
  return /* @__PURE__ */ jsx(Box, { ...rest, ref, children: /* @__PURE__ */ jsx(Button.Group, { className: ButtonGroupStyles.root, children: buttons.map((button) => /* @__PURE__ */ jsx(
    Button$1,
    {
      href: button.href,
      target: button.target,
      text: button.text,
      icon: button.icon,
      iconPosition: "left",
      onClick: button.onClick,
      variant,
      disabled,
      type,
      fullWidth
    },
    button.text
  )) }) });
});
_ButtonGroup.displayName = "ButtonGroup";
const ButtonGroup = sharedHandler(_ButtonGroup);
ButtonGroup.displayName = _ButtonGroup.displayName;
export {
  ButtonGroupStyles as B,
  ButtonGroup as default
};
